import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import AspectRatio from "@mui/joy/AspectRatio";
import routes from "./routes";

import icon_music from "../static/images/icon-music.png";
import icon_live_news from "../static/images/icon-live-news.png";
import icon_tic_tac_toe from "../static/images/icon-tic-tac-toe.jpg";
import icon_western_chess from "../static/images/icon-western-chess.jpg";
import icon_chinese_chess from "../static/images/icon-chinese-chess.jpg";
import icon_health_info from "../static/images/icon-health-info.jpg";

import { AppSingleton } from "../services/user_config";

const SelectionPage = () => {
  const navigate = useNavigate();
  const appSingleton = new AppSingleton();
  const getRoute = (key) => {
    const a = routes.filter((_route) => {
      return _route.key === key;
    })[0];
    // console.log(a);
    return a.route;
  };

  return (
    <>
      <Grid
        container
        spacing={4}
        sx={{ mt: 8, pl: 2, pr: 2 }}
        justifyContent="space-around"
      >
        {/* <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea>
              <CardMedia
                component="img"
                image={icon_main}
                alt="HomePage"
                sx={{ objectFit: "contain" }}
              />
            </CardActionArea>
          </Card>
        </Grid> */}
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("music-section-listing"))}
            >
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_music}
                  alt="Music"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  音樂放鬆站
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea onClick={() => navigate(getRoute("news-section"))}>
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_live_news}
                  alt="News"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  新聞資訊站
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("health-section-listing"))}
            >
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_health_info}
                  alt="Health Info"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  健康資訊站
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("game-tic-tac-toe-section"))}
            >
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_tic_tac_toe}
                  alt="Tic Tac Toe"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  趣味過三關
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("game-chinese-chess-section"))}
            >
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_chinese_chess}
                  alt="Chinese Chess"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  中國象棋
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("game-western-chess-section"))}
            >
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  image={icon_western_chess}
                  alt="International Chess"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  國際象棋
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={11} md={11}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea onClick={() => navigate(getRoute("testing"))}>
              <AspectRatio ratio={16 / 9}>
                <CardMedia
                  component="img"
                  alt="Testing"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
              <Box sx={{ display: "flex", justifyContent: "center", m: 1 }}>
                <Typography fontSize={appSingleton.windowSize.height / 48}>
                  Beta
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        </Grid>
        {/* <Grid item xs={5} md={5}>
          <Card sx={{ borderRadius: 4 }}>
            <CardActionArea onClick={() => navigate(getRoute("gpt-section"))}>
              <AspectRatio ratio={1}>
                <CardMedia
                  component="img"
                  // image={icon_live_news}
                  alt="GPT"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
            </CardActionArea>
          </Card>
        </Grid> */}
        {/* <Grid item xs={5} md={5}>
          <Card sx={{ borderRadius: 12 }}>
            <CardActionArea
              onClick={() => navigate(getRoute("robot-stream-section"))}
            >
              <AspectRatio ratio={1}>
                <CardMedia
                  component="img"
                  // image={icon_live_news}
                  alt="Robot Stream"
                  sx={{ objectFit: "contain" }}
                />
              </AspectRatio>
            </CardActionArea>
          </Card>
        </Grid> */}
      </Grid>
      {/* <Routes>
        {routes.map(({ name, key, icon, route, component }) => (
          <Route key={key} path={route} element={component}></Route>
        ))}
      </Routes> */}
    </>
  );
};

export { SelectionPage };
